export default {
  en: 'English',
  de: 'Deutsch',
  global: {
    yes: 'Ja',
    no: 'Nein',
    cancel: 'Abbrechen',
    amount: 'Menge',
    noImageAvailable: 'Kein Bild vorhanden',
    totalPrice: 'Summe',
    delete: 'Löschen',
    remove: 'Entfernen',
    restore: 'Wiederherstellen',
    notes: 'Notizen',
    edit: 'Bearbeiten',
    downloadPdf: 'PDF downloaden',
    readMore: 'Mehr erfahren',
    logout: 'Abmelden',
    generate: 'Generieren',
    back: 'Zurück',
    forward: 'Weiter',
    of: 'von'
  },
  common: {
    error: {
      error: 'Es ist ein Fehler aufgetreten',
      unknown: 'Unbestimmter Fehler',
      noAdditionalInfo: 'Keine weiteren Informationen verfügbar.',
      whileCommunicatingWithServer: 'Fehler bei der Kommunikation mit dem Server ({errorName})',
      networkIssues: 'Gibt es Probleme mit dem Netzwerk? ({errorName})',
      infoShort: 'Info',
      information: 'Information'
    },
    user: {
      myAccount: 'Mein Konto',
      changePassword: 'Passwort ändern',
      username: 'Benutzername'
    },
    product: {
      product: 'Artikel',
      products: 'Artikel',
      netQuantity: 'Nettofüllmenge',
      withSku: '@:common.product.product {sku}',
      withUvp: '@:productDetail.productProperties.grossPrice: {uvp}',
      inBaseUnit: 'in Grundeinheit',
      salesUnit: 'Verkaufsmengeneinheit',
      pricePerUnit: 'Einzelpreis',
      productImage: 'Produktbild',
      tieredPrices: 'Staffelpreise',
      basePrice: 'Grundpreis',
      productDescription: 'Produktbeschreibung',
      ingredients: 'Inhaltsstoffe',
      storageNote: 'Aufbewahrungshinweis',
      allergens: 'Allergene',
      allergencode: {
        gluten: 'Glutenhaltige Getreide',
        crab: 'Krebstiere',
        eggs: 'Eier',
        fish: 'Fisch',
        peanuts: 'Erdnüsse',
        soy: 'Soja',
        milk: 'Milch',
        ediblenut: 'Schalenfrüchte',
        celery: 'Sellerie',
        mustard: 'Senf',
        sesame: 'Sesamsamen',
        sulfite: 'Schwefeld. und Sulfite',
        lupine: 'Lupine',
        molluscs: 'Weichtiere',
      },
      attributes: {
        frozen: 'tiefgekühlt',
        cooled: 'gekühlt',
        weigh: 'Wiegeartikel',
        bio: 'BIO',
        vegan: 'vegan',
        lf: 'laktosefrei',
        gf: 'glutenfrei',
        preOrderItem: 'Vorbestellartikel',
        msc: 'MSC - Zertifizierte nachhaltige Fischerei',
        asc: 'ASC - Verantwortungsvolle Fischzucht',
        amagenuss: 'AMA Genussregion'
      },
      virtualCategories: {
        RIED: 'OurTipp',
        COOK: 'Cook',
        NATUR: 'Natürlich für uns',
        ECO: 'TransGourmet Economy',
        NAT: 'TransGourmet Natura',
        PREMI: 'TransGourmet Premium',
        QUALI: 'TransGourmet Quality',
        VONA: 'TransGourmet Vonatur',
        CONVI: 'Convenience',
      }
    },
    category: {
      categories: 'Warengruppen',
    },
    customer: {
      customer: 'Kunde',
      customerWithId: '@:common.customer.customer {customerId}',
      customerNumber: 'Kundennummer',
      withNumber: '@:common.customer.customer {customerNumber}',
      address: {
        deliveryAddress: 'Lieferadresse',
        unloadingArea: 'Abladestelle',
        customerAddress: 'Anschrift',
      }
    },
    cart: {
      cart: 'Warenkorb',
      addToCart: 'Zum Warenkorb hinzufügen',
      inCart: 'Im Warenkorb',
      quantityChangedInCart: 'Menge wurde im Warenkorb geändert.',
      unitChangedInCart: 'Einheit wurde im Warenkorb geändert.',
    },
    order: {
      order: 'Bestellung',
      orderNumberWithId: 'Bestellnummer {orderId}',
      orderNumberWithIdInHtml: 'Bestellnummer {0}', // we need to use unnamed variables because <i18n> blocks
      // cant handle named variables in current i18n version.
      deliveryDate: 'Liefertermin',
      customerOrderNumber: 'Referenznummer',
      customerOrderNumberWithId: '@:common.order.customerOrderNumber {customerOrderId}',
      item: {
        items: 'Positionen'
      }
    },
    amountSelector: {
      error: {
        invalidAmount: 'Ungültige Stückzahl - Mindestmenge: {lowerBound}',
        invalidAmountForProduct: 'Ungültige Stückzahl für Artikel {sku} {productName} - Mindestmenge: {minQty}'
      }
    },
    labelSelection: {
      removeFromLabelPrintList: 'Aus Etikettendruck entfernen',
      addToLabelPrintList: 'Zu Etikettendruck hinzufügen'
    },
    orderTemplateSelection: {
      addToOrderTemplate: 'Zu Bestellvorlage hinzufügen',
      removeFromOrderTemplate: 'Von Bestellvorlage entfernen',
    },
    inventory: {
      inventories: 'Inventuren'
    },
    customerSelector: {
      error: {
        noActiveCustomers: 'Ihnen ist kein aktiver Kunde zugeordnet. ' +
          'Wenden Sie sich bitte beim Riedhart Kundendienst.'
      },
    },
  },
  header: {
    customerSelector: {
      myAccount: '@:common.user.myAccount',
      customerWithId: '@:common.customer.customerWithId',
      changeCustomer: 'Kunde wechseln',
      myOrders: 'Meine Bestellungen',
      documents: 'Beleg-Abfrage',
      inventories: '@:common.inventory.inventories',
      downloadLmivList: 'Allergenliste downloaden',
      changePassword: '@:common.user.changePassword',
      logout: '@:global.logout',
      noActiveCustomers: '@:global.customerSelector.error.noActiveCustomers',
    },
    messageBar: {
      pleaseMakeSureYouHaveInternet: 'Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben.'
    },
    orderListsDropdown: {
      orderLists: 'Bestell-Listen',
      orderTemplates: 'Bestellvorlagen',
      bfOrders: '@:bfOrder.bfOrders',
    },
    userMenu: {
      myAccount: '@:common.user.myAccount',
      changePassword: '@:common.user.changePassword',
      logout: '@:global.logout'
    },
    shoppingCart: '@:common.cart.cart'
  },
  searchForm: {
    searchPlaceHolder: 'Ich suche ...',
    showAllResults: 'im Artikelstamm',
    showEssenceResults: 'in Essenzliste',
    showAllProductsFor: 'Alle {totalAmount} Artikel anzeigen für: "{query}"',
    categories: '@:common.category.categories',
    articles: '@:common.product.products',
    searchAutoCompletionProduct: {
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    }
  },
  searchResult: {
    productBadges: {
      specialPriceAbbr: 'Sonder',
      promotionPriceAbbr: 'Aktion'
    },
    resultShoppingCartControl: {
      productHasBeenRemovedFromTemplate: '{0} wurde aus der Vorlage entfernt.',
      restore: '@:global.restore',
      sponsored: 'Gesponsert',
      addToCart: '@:common.cart.cart',
      inCart: '@:common.cart.inCart',
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      productHasChangedInTemplate: 'Artikel wurde in der Bestellvorlage geändert.',
      remove: '@:global.remove',
      saveChangesInTemplate: 'Änderung in Vorlage speichern',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    }
  },
  cartPage: {
    header: {
      totalPrice: '@:global.totalPrice',
      continueShopping: 'Weiter einkaufen',
      customerWithNumber: '@:common.customer.customer: {customerId}',
      username: '@:common.user.username: {username}',
      steps: {
        cart: '@:common.cart.cart',
        delivery: 'Lieferdetails',
        confirmation: 'Bestätigung',
        buttonCaption: {
          goToDeliveryDetails: 'Weiter zu Lieferdetails',
          submitOrder: 'Bestellung abschicken'
        }
      }
    },
    preOrderSection: {
      preOrderItemDeliveryTimeNote: 'Folgende Artikel können eine längere Lieferzeit haben',
      numberOfPreOrderItems: 'Keine Vorbestellartikel | 1 Vorbestellartikel | {totalItems} Vorbestellartikel',
      preOrderItem: {
        noImageAvailable: '@:global.noImageAvailable',
        product: '@:common.product.product',
        amount: '@:global.amount',
        inBaseUnit: '@:common.product.inBaseUnit',
        pricePerUnit: '@:common.product.pricePerUnit',
        totalPrice: '@:global.totalPrice',
      }
    },
    cartStep: {
      bfOrders: '@:bfOrder.bfOrders',
      bfOpenOrders: 'Keine offenen Aufträge | 1 offener Auftrag | {count} offene Aufträge',
      buttonBfOpenOrders: 'Zu den offenen Order Friend Aufträgen',
      totalProductsInCart: 'Keine Artikel im Warenkorb | 1 Artikel im Warenkorb | {totalItems} Artikel im Warenkorb',
      confirmEmptyDialog: {
        emptyCart: 'Warenkorb leeren',
        doYouReallyWantToEmpty: 'Wollen Sie den Warenkorb wirklich leeren?',
      },
      cartIsEmpty: 'Sie haben keine Artikel in Ihrem Einkaufswagen.',
      promotionTitle: 'Schon probiert?',
      cartItem: {
        noImageAvailable: '@:global.noImageAvailable',
        preOrderItem: '@:common.product.attributes.preOrderItem',
        itMightTakeLongerToDeliver: 'Es kann zu Wartezeiten kommen',
        remove: '@:global.remove',
        productHasBeenRemoved: '{0} wurde aus dem Einkaufswagen entfernt.',
        restore: '@:global.restore',
      },
      promotedProduct: {
        noImageAvailable: '@:global.noImageAvailable',
        addToCart: '@:common.cart.cart',
      },
      unavailableItems: {
        title: 'Nicht bestellbar:',
        removeAll: 'Alle entfernen'
      }
    },
    deliveryStep: {
      delivery: 'Lieferung',
      yourReference: 'Ihre Referenznummer',
      reference: '@:common.order.customerOrderNumber',
      deliveryDate: '@:common.order.deliveryDate',
      deliveryAddress: '@:common.customer.address.deliveryAddress',
      unloadingArea: '@:common.customer.address.unloadingArea',
      order: '@:common.order.order',
      totalProducts: 'Keine Artikel | 1 Artikel | {totalItems} Artikel',
      totalPrice: '@:global.totalPrice',
      customerData: 'Kundendaten',
      customerNumber: '@:common.customer.customerNumber',
      customerAddress: '@:common.customer.address.customerAddress',
      paymentMethod: {
        paymentMethod: 'Zahlungsart',
        invoice: 'Kauf auf Rechnung'
      },
      confirmationMailTo: 'Bestätigungsmail an',
      noReceiversAvailable: 'Keine Empfänger vorhanden.',
      editMailReceivers: '@:global.edit',
      notes: '@:global.notes',
      youCanAddCommentsForYourOrderHere: 'Hier können Sie besondere Anmerkungen zu Ihrer Bestellung eingeben.'
    },
    confirmationStep: {
      thankYouForYourOrder: 'Danke für Ihre Bestellung.',
      yourOrderHasBeenPlacedSuccessfully: 'Ihre Bestellung war erfolgreich!',
      orderNumberWithId: '@:common.order.orderNumberWithId',
      orderNumberWithIdInHtml: '@:common.order.orderNumberWithIdInHtml',
      customerOrderNumberWithId: '@:common.order.customerOrderNumberWithId',
      downloadPdf: '@:global.downloadPdf',
      viewOrder: 'Bestellung ansehen',
      anOrderConfirmationMailWillBeSentTo: 'Sie erhalten eine Bestellbestätigung per E-Mail an die von Ihnen ' +
        'angegebenen Adressen:',
      yourOrder: 'Ihre Bestellung',
      totalPrice: '@:global.totalPrice',
      orderItems: '@:common.order.item.items',
      customerWithNumber: '@:common.customer.customer {0}',
      orderedOnBy: 'Bestellt am {orderDate} von {orderedBy} aus dem Webshop.',
      yourDelivery: 'Ihre Lieferung',
      deliveryAddress: '@:common.customer.address.deliveryAddress',
      unloadingArea: '@:common.customer.address.unloadingArea',
      notes: '@:global.notes',
      deliveryDateUnknown: 'Lieferdatum nicht bekannt',
      noConfirmationMailAvailable: 'Keine E-Mailadressen vorhanden'
    }
  },
  bfOrder: {
    bfOrders: 'Order Friend Aufträge',
    deliveryAddressAndUnloadingArea: '@:common.customer.address.deliveryAddress - ' +
      '@:common.customer.address.unloadingArea',
    createdOn: 'Erstellt am',
    products: '@:common.product.products',
    totalPrice: '@:global.totalPrice',
    confirmDeleteDialog: {
      delete: '@:global.delete',
      doYouReallyWantToDelete: 'Wollen Sie diese offene Order Friend Bestellung wirklich löschen?'
    },
    addToCart: '@:common.cart.cart',
    error: {
      productsCouldNotBeImported: 'Folgende Artikel wurden von Ihnen am Order Friend erfasst aber nicht importiert: ' +
        '{0}. Diese Artikel konnten aber nicht importiert werden, weil die Artikel bzw. die erfasste Mengeneinheit ' +
        'nicht mehr zum Verkauf angeboten werden.',
      deliveryAddressOrUnloadingAreaDoesNotExist: 'Die am Order Friend ausgewählte Lieferadresse bzw. Abladestelle ' +
        'existiert nicht. Während des Bestellvorgangs bitte eine entsprechende Adresse auswählen.'
    },
    item: {
      noImageAvailable: '@:global.noImageAvailable',
      amount: '@:global.amount',
      salesUnit: '@:common.product.salesUnit',
      pricePerUnit: '@:common.product.pricePerUnit',
      totalPrice: '@:global.totalPrice',
    }
  },
  cms: {
    featuredProduct: {
      noImageAvailable: '@:global.noImageAvailable',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    },
    featuredProducts: {
      noPromotionsCurrently: 'Derzeit keine Aktionen verfügbar'
    },
    promoProducts: {
      noImageAvailable: '@:global.noImageAvailable',
    },
    teaserTiles: {
      readMore: '@:global.readMore'
    }
  },
  cookieNotice: {
    thisSiteUsesCookies:
      'Unser Webshop nutzt Cookies und Trackingtools um die Nutzung unserer Services zu analysieren. ' +
      'Mit diesen Daten können wir das Benutzererlebnis laufend verbessern und optimieren. ' +
      'Alle weiteren Details finden Sie auf den Seiten "Datenschutz" und "Impressum".',
    header: 'Ihre Privatsphäre ist uns wichtig',
    essential: 'Essenziell',
    statistics: 'Statistiken',
    onlySelectedCookies: 'Auswahl speichern',
    allCookies: 'Alle akzeptieren',
    showDetails: 'Details einblenden',
    hideDetails: 'Details ausblenden',
    matomoDescription: 'Mit den entsprechenden Analyse-Werkzeugen können wir unsere Benutzer besser verstehen und ' +
      'unsere Services laufend verbessern und ausbauen. ' +
      'Unter anderem werden die aufgerufenen Seiten und die Verwaltung des Warenkorbes aufgezeichnet.'
  },
  essential: {
    addAllEssencesToLabelSelectionButton: {
      addAllToLabelPrint: 'Alle zu Etikettendruck hinzufügen',
      doYouReallyWantToAddAll: 'Wollen Sie wirklich alle Artikel zum Etikettendruck hinzufügen?'
    },
    essenceHideButton: {
      visibleOnEssenceList: 'Auf Essenzliste eingeblendet',
      hiddenOnEssenceList: 'Auf Essenzliste ausgeblendet'
    }
  },
  inventories: {
    inventoriesDeleteButton: {
      delete: '@:global.delete',
      doYouReallyWantToDelete: 'Wollen Sie die Inventur wirklich löschen?',
      inventoryWithItemsHasBeenDeleted: 'Inventur vom {inventoryDate} mit {totalItems} Position wurde gelöscht! | ' +
        'Inventur vom {inventoryDate} mit {totalItems} Positionen wurde gelöscht!'
    }
  },
  labelPrint: {
    labelPrint: 'Etikettendruck',
    generateLabelList: 'Etikettenliste generieren',
    confirmEmptyDialog: {
      emptyList: 'Etikettenliste leeren',
      doYouReallyWantToEmpty: 'Wollen Sie die Etikettenliste wirklich leeren?'
    },
    productsInLabelPrintList: 'Kein Artikel in der Etikettendruckliste | 1 Artikel in der Etikettendruckliste |' +
      '{totalItems} Artikel in der Etikettendruckliste',
    item: {
      remove: '@:global.remove',
      productHasBeenRemoved: '{0} wurde aus der Etikettenliste entfernt.',
      restore: '@:global.restore',
      productWithSku: '@:common.product.withSku'
    }
  },
  orderTemplate: {
    orderTemplateButtons: {
      addAllToCart: 'Alle zu Warenkorb hinzufügen',
      setQuantityZero: 'Menge auf 0 setzen',
      downloadAsPdf: 'Als PDF herunterladen',
      allProductsWithQuantityHaveBeenAddedToCart: 'Alle Artikel mit einer Menge größer 0 wurden erfolgreich zum ' +
        'Warenkorb hinzugefügt.'
    },
    orderTemplateDeleteButton: {
      deleteTemplate: 'Vorlage löschen',
      doYouReallyWantToDelete: 'Wollen Sie die Bestellvorlage wirklich löschen?'
    },
    orderTemplateEditForm: {
      createdByOn: 'Erstellt von {userName} {createdDate}', // 'am'/'on' is added to createdDate variable automatically
      todayWithDate: 'heute, {date}',
      onDayWithDate: 'am {date}',
      updatedByOn: 'Aktualisiert von {userName} {updatedDate}',
      yourPersonalNotes: 'Ihre persönlichen Notizen',
      showNotes: 'Notizen einblenden',
      hideNotes: 'Notizen ausblenden',
    },
    orderTemplatePdfButton: {
      downloadAsPdf: '@:orderTemplate.orderTemplateButtons.downloadAsPdf',
      onlyText: 'Nur Text',
      includeImagesAndBarcodes: 'Mit Bildern und Barcodes',
      generate: '@:global.generate',
      cancel: '@:global.cancel'
    },
  },
  fair: {
    deliveryStep: {
      requestedDeliveryDayFreshProducts: 'Wunschliefertermin (frisch)',
      requestedDeliveryDay: 'Wunschliefertermin (trocken)'
    },
    product: {
      priceBadge: 'Sonderangebot'
    }
  },
  productDetail: {
    detailPurchaseSection: {
      tieredPrices: '@:common.product.tieredPrices',
      addToCart: '@:common.cart.cart',
      inCart: '@:common.cart.inCart',
      priceForQuantityAndAbove: 'ab {minQuantity} {unit}',
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      invalidAmount: '@:common.amountSelector.error.invalidAmount',
      fromQuantityAndAbove: 'ab {minQuantity} {unit}'
    },
    essenceList: {
      visibleOnEssenceList: '@:essential.essenceHideButton.visibleOnEssenceList',
      hiddenOnEssenceList: '@:essential.essenceHideButton.hiddenOnEssenceList',
      days: 'Tag | Tage',
      weeks: 'Woche | Wochen',
      months: 'Monat | Monaten',
      aTimeFrameAgo: 'vor {timeFrame}'
    },
    productInformation: {
      productDescription: '@:common.product.productDescription',
      ingredients: '@:common.product.ingredients',
      storageNote: '@:common.product.storageNote',
      allergens: '@:common.product.allergens',
      containedAllergens: 'Enthaltene Allergene',
      noImageAvailable: '@:global.noImageAvailable',
      containedTracesOfAllergens: 'Enthaltene Allergenspuren',
      documents: 'Dokumente',
      dataSheet: 'Datenblatt'
    },
    productProperties: {
      specialPriceValidUntil: 'SONDERPREIS {0}',
      promotionPriceValidUntil: 'AKTIONSPREIS {0}',
      priceValidUntil: 'gültig bis {priceToDate}',
      product: '@:common.product.product',
      netQuantity: '@:common.product.netQuantity',
      basePrice: '@:common.product.basePrice',
      grossPrice: 'UVP',
    },
  },
  notifications: {
    webshop: 'Webshop',
    sms: 'SMS',
    email: 'E-Mail',
    save: 'Änderungen speichern'
  },
  notificationCenter: {
    filter: 'Filter',
    filterAll: 'Typ: Alle',
    customer: 'Kunde',
    customers: 'Kunden',
    markRead: 'Als gelesen markieren',
    attachment: 'Anhang',
    youHave: 'Sie haben',
    unreadMessage: 'ungelesene Nachricht.',
    unreadMessages: 'ungelesene Nachrichten.',
    checkAll: 'alle ungelesenen markieren'
  },
  notificationModal: {
    furtherImportantNotifications: 'Es gibt noch weitere wichtige Benachrichtigungen:'
  },
  addToCart: {
    cart: '@:common.cart.cart',
    inCart: '@:common.cart.inCart',
    preOrderBold: 'Vorbestellartikel',
    preOrderSuffix: ' - bitte telefonisch bestellen!',
    notDeliverable: 'Artikel im Moment nicht verfügbar!',
    conviItem: 'Bestellbar bis 14 Uhr für nächsten Liefertag!'
  }
};
